'use client';
import React from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Drawer, DrawerContent, DrawerTitle } from '@/components/ui/drawer';
// import { useGetUserAvatarList } from '../../services/user';
import clsx from 'clsx';
// import ModalTitle from '../modal-title';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import '@/features/user-center/styles/btn.css';
import { track } from '@/utils/track';

interface ModalSeconsConfirmProps {
  /** 弹窗标题 */
  title?: string;

  content?: string;
  /** 自定义样式 */
  className?: string;
  /** 取消按钮的回调函数 */
  onCancle?: () => void;
  /** 确定按钮的回调函数 */
  onSure?: () => void;
}
interface ModalSeconsConfirmReturnType {
  result?: boolean;
}

// Main Modal Component
const ModalSeconsConfirm = NiceModal.create<ModalSeconsConfirmProps>(({
  content = '',
  className,
  onCancle,
  onSure,
}) => {
  const modal = useModal();
  const t = useTranslations('personal');
  const handleCancle = () => {
    onCancle?.();
    modal.resolve(false);
    modal.hide();
  };
  const handleSure = () => {
    track('profile_page_button_click', {
      current_page: 'Personal Center',
      button_name: 'Logout',
    });
    onSure?.();
    modal.resolve(true);
    modal.hide();
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      handleCancle();
    }
  };

  return (
    <Drawer open={modal.visible} onOpenChange={handleOpenChange}>
      <DrawerTitle></DrawerTitle>
      <DrawerContent className={clsx(
        "bg-surface",
        className
      )}>
        {/* <ModalTitle className='pb-0' title={title} showBack={false} onClose={handleCancle} showClose={true} /> */}
        <div className='w-full flex flex-col items-center px-[27px] pb-[31px]'>
          {
            content && (
              <div className='py-[3.75rem] w-full h-[5.8125rem]  flex items-center justify-center font-medium text-xs text-tertiary leading-[.9375rem]'>{content}</div>
            )
          }
          <div className="flex items-center w-full">
            <Button onClick={handleCancle} className='flex-1 info-btn large-btn mr-2.5 !text-s'>{t('common.cancel')}</Button>
            <Button onClick={handleSure} className='flex-1 primary-btn large-btn'>{t('oKToExit')}</Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
});

ModalSeconsConfirm.displayName = 'ModalSeconsConfirm';

// eslint-disable-next-line react-refresh/only-export-components
export const showModalSeconsConfirm: (props: ModalSeconsConfirmProps) => Promise<ModalSeconsConfirmReturnType> = (props) => {
  return NiceModal.show(ModalSeconsConfirm, props);
};

export default ModalSeconsConfirm;